export const isDateTime = filterType => filterType === 'date_time';
//# sourceMappingURL=is_date_time.js.map